export default __webpack_public_path__ + "static/media/arrosage_arr1.191b82e2.png";